module.exports = __webpack_public_path__ + "img/logo_new.e5c5de84.svg";